import React, { useState, useEffect } from 'react'
import { Autocomplete } from '@material-ui/lab';
import { matchSorter } from 'match-sorter';
import { Button, Box } from '@material-ui/core'

import {
  TextField,
} from '@material-ui/core';

const filterOptions = (options, inputValue) => {
  return matchSorter(options, inputValue, {keys: ['name']});
}

export default function RefSelect(props) {

  var {
    options,
    initialValue,
    error,
    onUpdate,
    onCreate,
    onCreateText,
    placeholder,
    label,
    disableUnderline = false,
  } = props;

  options = options || [];
  initialValue = initialValue || null;

  const [Ref, setRef] = useState(initialValue);

  useEffect(() => {
    const newVal = initialValue || {};
    const oldVal = Ref || {};
    const { id: newId = null } = newVal;
    const { id: oldId = null } = oldVal;
    if (newId != oldId) {
      setRef(initialValue)
    }
  }, [initialValue])
  
  const handleUpdate = (value) => {
    setRef(value)
    onUpdate(value)
  }

  return (
    <div>
      {onUpdate && <Autocomplete
        options={options}
        getOptionLabel={option => option.name || ''}
        getOptionSelected={(option, value)=> option.id === value.id}
        value={Ref}
        autoHighlight={true}
        onChange={(event, value) => { handleUpdate(value)}}
        { ...(onCreate &&
          {noOptionsText: (
            <Box display="flex" justifyContent="space-between" alignItems="center">
              No match found
              <Button
                variant="outlined"
                color="primary"
                onMouseDown={onCreate}
              >
              + Add new
              </Button>
            </Box>
          )}
        )}
        filterOptions={(options, {inputValue}) => filterOptions(options, inputValue)}
        renderInput={(params) => <TextField
          {...params}
          label={label}
          {...(disableUnderline && {InputProps: {...params.InputProps, disableUnderline: !error}})}
          {...(error && { error: true })}
          placeholder='Type to search'
          InputLabelProps={{ shrink: true }}
        />}
      />}
    </div>
  )
}
